import React from 'react';
import notFound from '../../../public/404.svg';
import { Typography } from 'antd';
const NotFound = () => {
	return (
		<div className="flex flex-1 h-full justify-center gap-x-12">
			<div className="flex-1 max-w-[320px] justify-center items-center flex">
				<img src={notFound} />
			</div>
			<div className="flex  flex-col justify-center">
				<Typography.Title>Oopss!!</Typography.Title>
				<Typography.Text>
					Its looks like we dont have what you are looking for !!
				</Typography.Text>
			</div>
		</div>
	);
};

export default NotFound;
